
type DebugLogSubscriber = (logs: string[]) => void;

class BugBust {
  private logs: string[] = [];
  private subscribers: DebugLogSubscriber[] = [];

  // Adds a new log message with a timestamp.
  public add(message: string) {
    const timestamp = new Date().toISOString();
    const logMessage = `[${timestamp}] ${message}`;
    this.logs.push(logMessage);
    // Notify subscribers of the new log array.
    this.subscribers.forEach(callback => callback(this.logs));
  }

  // Returns the current log array.
  public getLogs(): string[] {
    return this.logs;
  }

  // Allows components to subscribe to log updates.
  public subscribe(callback: DebugLogSubscriber) {
    this.subscribers.push(callback);
    // Return an unsubscribe function.
    return () => {
      this.subscribers = this.subscribers.filter(sub => sub !== callback);
    };
  }
}

const bugBustInstance = new BugBust();
export default bugBustInstance;
